import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router";

export type StoreTab = "products" | "orders" | "settings";

const PATHS: Record<StoreTab, string> = {
  orders: "/store",
  products: "/store/products",
  settings: "/store/settings",
};

/** The Store's tabs: the orders to hand over or ship first, then what the church sells, then how it sells. */
export function StoreTabs({ active }: { readonly active: StoreTab }) {
  const navigate = useNavigate();
  return (
    <Tabs
      value={active}
      onChange={(value) => {
        if (value !== null && value in PATHS) void navigate(PATHS[value as StoreTab]);
      }}
      mb="lg"
    >
      <Tabs.List>
        <Tabs.Tab value="orders">Orders</Tabs.Tab>
        <Tabs.Tab value="products">Products</Tabs.Tab>
        <Tabs.Tab value="settings">Settings</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
